import Image from "components/Image"
import Link from "next/link"
import storyblokImageLoader from "utilities/storyblokImageLoader"

export default function Card({ image, slug, name, excerpt }) {
  return (
    <div className="border-0.5 border-grey-cool bg-white h-full">
      <Link href={slug} title={name}>
        <Image
          loader={image?.filename && image?.filename !== "" ? storyblokImageLoader : undefined}
          src={image?.filename && image?.filename !== "" ? image.filename : "/assets/placeholder.png"}
          alt={name ?? ""}
          placeholder={image?.blurDataURL ? "blur" : "empty"}
          blurDataURL={image?.blurDataURL}
          width={299}
          height={153}
          className="w-full aspect-[2/1] object-cover"
          sizes="(max-width: 1024px) 45vw, (max-width: 640px) 95vw, 20vw"
        />
      </Link>
      <div className="py-7 px-4 xl:px-7">
        <Link className="bracket-link relative block w-full mr-8" href={slug}>
          <h2 className="text-m2 font-semibold text-primary text-center">{name}</h2>
        </Link>
        {excerpt?.length > 0 ? <p className="pt-4">{excerpt}</p> : null}
      </div>
    </div>
  )
}
